import { useState, useCallback } from "react";
import useApi from "../../../utils/api";

export const useUpdateTimeSheet = ({ isMyTimesheet }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const { authPut } = useApi();

	const submit = useCallback(
		async (id, data, onSuccess, onFailure) => {
			setLoading(true);
			setError(null);
			try {
				const url = isMyTimesheet ? `/time-sheet/${id}` : `/time-sheet/my-team/${id}`;
				const response = await authPut(url, { data });
				await onSuccess?.(response);
			} catch (err) {
				await onFailure?.(err);
				setError(err);
			} finally {
				setLoading(false);
			}
		},
		[authPut]
	);

	return { submit, loading, error };
};